<template>
  <nav class="l-navigationmain navigationmain" role="navigation" aria-label="navigation">
    <ul>
      <display-menu :link="link" v-for="(link, i) in links" :key="i + '-' + link.routeName"></display-menu>
    </ul>
  </nav>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import { orderBy } from 'lodash'

  export default {
    name: 'AppLeftMenu',
    computed: {
      ...mapGetters(['isLog', 'isAdmin', 'isManager', 'isSectorManager', 'isSeller', 'isOperator', 'isDistributeurMode', 'currentUserProfil']),
      ...mapState(['currentUser', 'configs']),
      advTerm () {
        if (!this.configs) return
        let term = {
          FRA: 'ADV',
          MAR: 'Réservations'
        }
        return term[this.configs.COUNTRY]
      },
      links () {
        let links = this.linksData
        /* if (this.isDistributeurMode) {
          let routeNames = (links['stock']['children']) ? links['stock']['children'].map(x => x.routeName) : []
          if (!routeNames.includes('PromoteurList') && (this.isAdmin || this.currentUserProfil === 'editor')) {
            links.stock.children = []
            links['stock']['children'].push({
              routeName: 'PromoteurList',
              text: 'Promoteurs',
              needProfile: ['admin', 'editor'],
              children: [
                {
                  routeName: 'PromoteurList',
                  text: 'Les promoteurs',
                  needProfile: ['admin', 'editor']
                },
                {
                  routeName: 'FluxList',
                  text: 'Les flux',
                  needProfile: ['superadmin']
                },
                {
                  routeName: 'PromoteurCreate',
                  text: 'Ajouter un promoteur',
                  needProfile: ['admin', 'editor'],
                  iconClasses: ['fal', 'fa-plus-circle']
                }
              ]
            })
          }
        } */
        if (this.currentUser && this.currentUser.pole_accesses && this.currentUser.pole_accesses.length > 0) {
          links.stats.needProfile.push('seller')
          links.stats.childrenOld[0].needProfile.push('seller')
          links.stats.childrenOld[0].children[0].needProfile.push('seller')
          links.stats.routeName = 'SellerStats'
          links.stats.childrenOld[0].routeName = 'SellerStats'
        }
        links = Object.values(links)
        return orderBy(links, 'position')
      },
      linksData () {
        return {
          home: {
            position: 0,
            routeName: 'Home',
            text: 'Accueil',
            needProfile: ['admin'],
            iconClasses: ['fal', 'fa-columns', 'is-size-2']
          },
          stock: {
            position: 1,
            routeName: 'StockPrograms',
            text: 'Stocks',
            iconClasses: ['fal', 'fa-city', 'is-size-2'],
            needProfile: ['admin', 'manager', 'editor', 'seller', 'manager_ext', 'seller_ext', 'sector_manager'],
            childrenOld: [
              {
                routeName: 'StockPrograms',
                text: 'Stock',
                children: [
                  {
                    routeName: 'StockPrograms',
                    text: 'Programmes et lots'
                  },
                  {
                    routeName: 'ProgramCreate',
                    text: 'Nouveau programme',
                    needProfile: ['admin', 'editor'],
                    iconClasses: ['fal', 'fa-plus-circle']
                  },
                  {
                    routeName: 'OptionList',
                    text: 'Options en cours',
                    badge: 'options',
                    needProfile: ['admin', 'manager', 'seller', 'manager_ext', 'seller_ext']
                  },
                  {
                    routeName: 'LotWishlistList',
                    text: 'Favoris',
                    badge: 'wishlists'
                  }
                ]
              },
              {
                routeName: 'AccessList',
                text: 'Mandats',
                needProfile: ['admin'],
                children: [
                  {
                    routeName: 'AccessList',
                    text: 'Liste',
                    needProfile: ['admin']
                  },
                  {
                    routeName: 'AccessCreate',
                    text: 'Nouveau mandat',
                    needProfile: ['admin'],
                    iconClasses: ['fal', 'fa-plus-circle']
                  }
                ]
              }
            ]
          },
          contacts: {
            position: 2,
            routeName: 'ContactList',
            iconClasses: ['fal', 'fa-id-card', 'is-size-2'],
            text: 'Contacts',
            needProfile: ['admin', 'manager', 'manager_ext', 'operator', 'seller', 'seller_ext', 'sector_manager'],
            childrenOld: [
              {
                routeName: 'ContactList',
                text: 'Contacts',
                iconClasses: ['fa-lg', 'fal', 'fa-id-card'],
                children: [
                  {
                    routeName: 'ContactList',
                    text: 'Les contacts'
                  },
                  {
                    routeName: 'ContactCreate',
                    text: 'Ajouter un contact'
                  },
                  {
                    routeName: 'DenunciationList',
                    text: 'Dénonciations',
                    badge: 'denunciations'
                  }
                ]
              },
              {
                routeName: 'OriginList',
                text: 'Origines',
                needProfile: ['admin'],
                children: [
                  {
                    needProfile: ['admin'],
                    routeName: 'OriginList',
                    text: 'Liste des origines contact'
                  },
                  {
                    needProfile: ['admin'],
                    routeName: 'OriginCreate',
                    text: 'Ajouter une origine',
                    iconClasses: ['fal', 'fa-plus-circle']
                  }
                ]
              },
              {
                routeName: 'LeadList',
                text: 'Leads',
                configs: ['LEAD_ENABLED'],
                children: [
                  {
                    routeName: 'LeadList',
                    text: 'Liste des leads'
                  }
                ]
              }
            ]
          },
          calendar: {
            position: 3,
            routeName: 'CalendarMonthView',
            text: 'Calendrier',
            iconClasses: ['fal', 'fa-calendar-alt', 'is-size-2'],
            needProfile: ['admin', 'manager', 'seller', 'operator', 'sector_manager'],
            childrenOld: [
              {
                routeName: 'CalendarMonthView',
                text: 'Calendrier',
                children: [
                  {
                    routeName: 'CalendarMonthView',
                    text: 'Mois en cours'
                  },
                  {
                    routeName: 'CalendarDayView',
                    text: 'Aujourd\'hui'
                  }
                ]
              },
              {
                routeName: 'CalendarList',
                text: 'Rendez-vous',
                children: [
                  {
                    routeName: 'CalendarList',
                    text: 'Rendez-vous',
                    needProfile: ['admin', 'manager', 'seller', 'operator']
                  },
                  {
                    routeName: 'CalendarCreate',
                    text: 'Nouveau rendez-vous',
                    needProfile: ['admin', 'manager', 'seller', 'operator']
                  }
                ]
              },
              {
                routeName: 'ReminderList',
                text: 'Rappels',
                children: [
                  {
                    routeName: 'ReminderList',
                    text: 'Mes rappels'
                  },
                  {
                    routeName: 'ReminderCreate',
                    text: 'Ajouter un rappel',
                    iconClasses: ['fal', 'fa-plus-circle']
                  }
                ]
              }
            ]
          },
          users: {
            position: 4,
            routeName: 'UserList',
            text: 'Utilisateurs',
            iconClasses: ['fal', 'fa-users', 'is-size-2'],
            needProfile: ['admin', 'manager', 'manager_ext', 'operator', 'sector_manager'],
            childrenOld: [
              {
                routeName: 'UserList',
                text: 'Utilisateurs',
                needProfile: ['admin', 'manager', 'manager_ext', 'operator', 'sector_manager'],
                children: [
                  {
                    needProfile: ['admin', 'manager', 'manager_ext', 'operator', 'sector_manager'],
                    routeName: 'UserList',
                    text: 'Les utilisateurs'
                  },
                  {
                    needProfile: ['admin', 'operator', 'sector_manager'],
                    method: () => {
                      let params = {
                        mode: 'append'
                      }
                      if (this.isOperator) {
                        params.facets = {
                          'USER': ['is_external:False']
                        }
                      }
                      this.$store.commit('setQuickview', {mode: 'NEW_EVENT', params: params})
                    },
                    text: 'Créer une annonce'
                  },
                  {
                    needProfile: ['admin', 'manager', 'manager_ext'],
                    routeName: 'UserCreate',
                    text: 'Ajouter un utilisateur',
                    iconClasses: ['fal', 'fa-plus-circle']
                  }
                ]
              },
              {
                routeName: 'PoleList',
                text: 'Pôles',
                needProfile: ['admin'],
                children: [
                  {
                    needProfile: ['admin'],
                    routeName: 'PoleList',
                    text: 'Les pôles'
                  },
                  {
                    needProfile: ['admin'],
                    routeName: 'PoleCreate',
                    text: 'Ajouter un pôle',
                    iconClasses: ['fal', 'fa-plus-circle']
                  }
                ]
              },
              {
                routeName: 'CompanyList',
                text: 'Sociétés',
                needProfile: ['admin'],
                children: [
                  {
                    needProfile: ['admin'],
                    routeName: 'CompanyList',
                    text: 'Les sociétés'
                  },
                  {
                    needProfile: ['admin'],
                    routeName: 'CompanyCreate',
                    text: 'Ajouter une société',
                    iconClasses: ['fal', 'fa-plus-circle']
                  }
                ]
              },
              {
                routeName: 'ExternalAccessList',
                text: 'Accès Externes',
                needProfile: ['admin'],
                children: [
                  {
                    needProfile: ['admin'],
                    routeName: 'ExternalAccessList',
                    text: 'Les accès'
                  },
                  {
                    needProfile: ['admin'],
                    routeName: 'ExternalAccessCreate',
                    text: 'Ajouter un accès',
                    iconClasses: ['fal', 'fa-plus-circle']
                  }
                ]
              }
            ]
          },
          adv: {
            position: 5,
            routeName: 'AdvList',
            iconClasses: ['fal', 'fa-tasks', 'is-size-2'],
            text: this.advTerm,
            needProfile: ['admin', 'manager', 'manager_ext', 'seller', 'seller_ext', 'sector_manager']
          },
          stats: {
            position: 6,
            routeName: 'SaleStats',
            needProfile: ['admin', 'manager'],
            configs: ['STATS_ENABLED'],
            iconClasses: ['fal', 'fa-tachometer-alt', 'is-size-2'],
            text: 'Statistiques',
            childrenOld: [
              {
                needProfile: ['admin', 'manager'],
                routeName: 'SaleStats',
                text: 'Statistiques',
                children: [
                  {
                    needProfile: ['admin', 'manager'],
                    routeName: 'SellerStats',
                    text: 'Vendeurs'
                  },
                  {
                    needProfile: ['admin', 'manager'],
                    routeName: 'SaleStats',
                    text: 'Ventes'
                  },
                  {
                    needProfile: ['admin'],
                    configs: ['MULTIDIFF_ENABLED'],
                    routeName: 'Multidiffusion',
                    text: 'Multidiffusion'
                  },
                  {
                    needProfile: ['admin', 'manager'],
                    routeName: 'RdvStats',
                    text: 'Rendez-vous'
                  }
                ]
              }
            ]
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/layout/LayoutLeftMenu.vue